import { randomInt } from "../../../services/utils";
import { getSemiRandomPercent } from "./getSemiRandomPercent";

export function placeBubbleInRectangle(
  bubble,
  targetRectangle,
  placedRectangles,
  refRectangleIndex,
  spacing
) {
  const [x1, y1, x2, y2] = targetRectangle;
  const rectangleWidth = x2 - x1;
  const rectangleHeight = y2 - y1;
  const bubbleWidth = bubble.size.width;
  const bubbleHeight = bubble.size.width;

  if (refRectangleIndex >= placedRectangles.length) {
    const xDelta = spacing;
    const yDelta = randomInt(15, spacing);

    return [
      x1 + xDelta,
      y1 + yDelta,
      x1 + xDelta + bubble.size.width,
      y1 + yDelta + bubble.size.width,
    ];
  }

  const refRectangle = placedRectangles[refRectangleIndex];
  const [x3, y3, x4, y4] = refRectangle;

  const maxXDelta = rectangleWidth - bubbleWidth;
  const maxYDelta = rectangleHeight - bubbleHeight;
  let xDelta = getSemiRandomPercent(
    spacing,
    maxXDelta,
    bubble.percent,
    placedRectangles.length + refRectangleIndex
  );
  let yDelta = getSemiRandomPercent(
    spacing,
    maxYDelta,
    bubble.percent,
    placedRectangles.length + refRectangleIndex
  );

  if (x1 === x4) {
    xDelta = spacing;
  } else if (x2 === x3) {
    xDelta = rectangleWidth - bubble.size.width - spacing;
  }

  if (y1 === y4) {
    yDelta = spacing;
  } else if (y2 === y3) {
    yDelta = rectangleHeight - bubble.size.width - spacing;
  }

  return [
    x1 + xDelta,
    y1 + yDelta,
    x1 + xDelta + bubble.size.width,
    y1 + yDelta + bubble.size.width,
  ];
}
